import { Component, OnInit } from '@angular/core';

import { IBcContest } from '../../../models/BcContest';
import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { bcState } from '../shared';

@Component({
    selector: 'app-bc-contest-list',
    templateUrl: './bc-contest-list.component.html'
})
export class BcContestListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: BcContestService
    ) { }

    readonly columns: ITableColumn[] = [
        { property: 'Name', label: 'bcContest_lblName', sorts: true },
        { property: 'Status', label: 'bcContest_lblStatus', sorts: true },
        { property: 'OpenedFrom', label: 'bcContest_lblOpenedFrom', sorts: true, type: 'date' },
        { property: 'OpenedTo', label: 'bcContest_lblOpenedTo', sorts: true, type: 'date' },
        { property: 'ResultsVisibleFrom', label: 'bcContest_lblResultsVisibleFrom', sorts: true, type: 'date' },
        { property: 'ResultsVisibleTo', label: 'bcContest_lblResultsVisibleTo', sorts: true, type: 'date' },
        { width: '1px' }
    ];

    items: IBcContest[] = [];

    ngOnInit() {
        bcState.clearCourses();
        bcState.clearApplications();

        this.load();
    }

    private load() {
        this.app.addLoading(this.service.get()).subscribe(data => {
            this.items = data;
        });
    }
}
